
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"46","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Vector Smart Object copy 5","width":"46","height":"46","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAADK0lEQVRogdWYT0hUURTGP5+N4AxYQZli4CZIm4JWCdNCAqG/tDNoUQTtsjbVol2B0CJxFwYtolUIEREIQagTbUVSKigQCleZxRhkGkZfPPiGLub8uffdN/P84DJv3pt7zo8z991zzm0gCQsdBHASwGEA3QA6AKQ0/RuAjwCmAUwAeA7gh41xG1UD3gTgHICrAPYZ91cBfALwS9/bAbQaz5cBPAJwB8Ccd/IQvMzoI/me/5QnOUCyi2TDBvNaSB4jOULyq2atkRwmmangy2qU+nEjySED+AnJ/ZbGm0leIbkoG2EAsnGCp0k+lbPPJI9HdLKd5KjsfSfZGwd4owE9Q7Ld4997XXaXSR7yDT5kQG/1uSY1BmR/gWSbL/A+Y3n4jHSp4LzwAd5k7B5R13SlkSI5JV/9UcEvGrtHnNDF0WPsNEEU8HcyZLvlRRlj8nnCxUagNB5mxJcA3nrPcKV1V0/Ou0wOwU/p+nHMoOs1DqAA4Kg4rBROyGnCZI3BfwN4BWAbgKwLeLcKpg/x8JXVrB522U4MVJqGVZ5VfetJ8zLT4QKeMkrTWmtJ/lpcwOupZvlecQEPO5e2OsHv1OdShd/9p0Dt1i6Xv8uD9sqEdYcUqEeEsS3WUjltCjMu4BO6Pl1j6E4ABwC8ViKyUqBuPGxszxgvSy10QT7cMraKlvsqeC7XqMDKqBdddW0oihd71I0vqkeMG/y2AjXiasP8MixjozFD9yhIBZKtPsAzRhd0LSbo3STn5eNsFFvrb2R1hBDqUgzQb2T7XlR7G93s1REC1dimPC2PYqSpE7G0b3Do3GNBTqbk2MVBRi/imhHpvK4no8CXe9imI4SixnQuuKUKw50kbxrHbwVjTacFHQm+mtPafgCDRl1RUOcyq3p6SYlrhxqCnDIiVC4/AHALwBfDZhrAGIAjAPJqH3+6JKBKI1A3PqroldMfktMkb1RILpEib3uwD5UJWUW3Q1XliiI/p4Kp2trDPfIedoyowynySQB3gk8KuDV8ksCt4JMGXjV8EsGrgk8qeEX4JIOXhU86eEn4zQC+IbxLyq+XzPJgfDOBhwrhnwF4+Bep9eabu4bhRgAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    